
    <h4 mat-dialog-title>AD TRACE(s)</h4>
    <div mat-dialog-content>
      <div class="d-flex flex-column">
        <span *ngFor="let link of domain.traces" class="d-inline-block" style="word-break: break-all">
          {{link}}
        </span>
      </div>
    </div>
    <div mat-dialog-actions class="mt-3 justify-content-center">
      <button mat-raised-button color="" [mat-dialog-close]="false">Close</button>
    </div>
  